'use strict';

var Backbone = require('backbone'),
  config = require('../../js/config'),
  utilities = require('../../js/utilities'),
  modelDefaults = config.registrationModelDefaults,
  $ = require('jquery'),

  RegistrationFormModel = Backbone.Model.extend({
    defaults: {
      companyName: modelDefaults.company,
      phoneNumber: modelDefaults.phone,
      country: modelDefaults.country,
      source: modelDefaults.source,
      fmt: modelDefaults.fmt
    },
    save: function save() {
      return $.ajax({
        type: 'POST',
        url: config.urls.registration.registerUser,
        data: utilities.addCustIpToDataObject(this.attributes),
        contentType: 'application/x-www-form-urlencoded'
        // Disabling error reporting due to inconsistencies of not being able to change language of response.
        // handleErrorLocally: true //stop global error in errorHandler
      });
    }
  });

module.exports = RegistrationFormModel;



// WEBPACK FOOTER //
// ./assets/components/Registration/RegistrationFormModel.js